/* eslint-disable no-undef */
export const auth_token = 'd29e1670-c947-4093-8c90-0ae1007ae042'
export const TIMEZONE = 'Europe/Paris' // OR TO GET TIMEZONE USER Intl.DateTimeFormat().resolvedOptions().timeZone;
export default {
  ENV: process.env.NODE_ENV,
  auth_token,
  BASE_URL: process.env.REACT_APP_API_V1,
  BASE_URL_V2: process.env.REACT_APP_API_V2,
  API_V1:
    window.location.origin.indexOf('internal') !== -1
      ? window.location.origin + '/api'
      : process.env.REACT_APP_API_V1,
  API_V2: process.env.REACT_APP_API_V2,
  APP_URL: process.env.REACT_APP_APP_URL,
  PUBLIC_URL: process.env.PUBLIC_URL,
  COPROMATIC_CONNECT: process.env.REACT_APP_COPROMATIC_CONNECT,
  APP_LOVYS: process.env.REACT_APP_LOVYS,
  COPROMATIC_EXTRANET: process.env.REACT_APP_COPROMATIC_EXTRANET,
  NOVU_APP_ID: process.env.REACT_APP_NOVU_APP_ID,
  TINY_API_KEY: process.env.REACT_APP_TINY_API_KEY,
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL,
  SEPA_ORDERS_URL: process.env.REACT_APP_SEPA_ORDERS_URL,
  MAX_NOTIFICATIONS_TO_DISPLAY: 5,
  REACT_APP_VAPID_KEY: process.env.REACT_APP_VAPID_KEY,
  REACT_APP_HELLO_APP_INTRANET: process.env.REACT_APP_HELLO_APP_INTRANET,
  REACT_APP_GMT_CODE: process.env.REACT_APP_GMT_CODE,
}
